export const ActionTabType = {
    ACTIONS: 'actions',
    ACTIONSCOMMONTROUBLESHOOTING: 'actionsCommonTroubleShooting',
};

export const ActionGroupType = {
    ACTIONS: 'actions',
    ACTIONSCOMMONTROUBLESHOOTING: 'actionsCommonTroubleShooting',
    ALL: 'all'
};

export const ActionType = {
    INTERNET: 'internet',
    CELLULAR: 'cellular',
    MAPA: 'mapa',
    TV: 'tv',
    BUNDLE: 'bundle',
    ERROR: 'error',
    INVOICES: 'invoices',
    NOPRODUCTS: 'noproduct'
};


export const ActionTypeDefault = {
    INTERNET: 'internet',
    CELLULAR: 'cellular',
    MAPA: 'mapa',
    TV: 'tv',
    BUNDLE: 'bundle',
    ERROR: 'error',
    INVOICES: 'invoices',
};